export const PLANS_ENUM = {
  FREE: 'Demo',
  PRO: 'Pro',
  BUSINESS: 'Business',
};

export const PROMOTED_PLAN = PLANS_ENUM.PRO;
